// extracted by mini-css-extract-plugin
export default {"ressource":"RessourceGroup_ressource__8DOX6"};